var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.25 1.5H12.75V0.5C12.7499 0.34845 12.6812 0.205109 12.563 0.11026C12.4448 0.0154114 12.29 -0.020752 12.142 0.0119934L3.142 2.01199C2.91309 2.06262 2.75009 2.26553 2.75 2.5V21.5C2.75009 21.7344 2.91309 21.9373 3.142 21.988L12.142 23.988C12.29 24.0207 12.4448 23.9846 12.563 23.8897C12.6812 23.7949 12.7499 23.6515 12.75 23.5V22.5H20.25C20.8023 22.5 21.25 22.0523 21.25 21.5V2.5C21.25 1.94769 20.8023 1.5 20.25 1.5ZM10.25 12.5C10.25 13.3284 9.57843 14 8.75 14C7.92157 14 7.25 13.3284 7.25 12.5C7.25 11.6716 7.92157 11 8.75 11C9.57843 11 10.25 11.6716 10.25 12.5ZM13.25 20.5H18.75C19.0261 20.5 19.25 20.2762 19.25 20V4C19.25 3.72385 19.0261 3.5 18.75 3.5H13.25C12.9739 3.5 12.75 3.72385 12.75 4V20C12.75 20.2762 12.9739 20.5 13.25 20.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/door.e65e131b.svg";
export { ForwardRef as ReactComponent };